<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="toc-header1">Wellington’s Infantry</h1>
<p class="subtitle">British Foot Regiments 1800–1815</p>
<p class="author">Gabriele Esposito</p>
<div class="img_container">
<img alt="images" src="images/pub.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?5c1869ec